import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Subject, Subscription, throwError, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import { Router } from '@angular/router';
import { VideoPortalUser } from '../auth/video-portal-user.model';
import { AuthConfigService } from '../auth-config/auth-config.service';
import { MsalService } from '@azure/msal-angular';

@Injectable()
export class TermsAndConditionsService implements OnDestroy {
    private _shown = new Subject<void>();
    private endpoint = 'terms-and-conditions';
    private currentUser: VideoPortalUser | null = null;
    private userSubscription: Subscription;

    get canAgreeToTermsAndConditions(): boolean {
        return !!this.currentUser
            && !this.currentUser.hasAgreedToTermsAndConditions
            && (this.currentUser.roles || []).length !== 0;
    }

    get hasAgreedToTermsAndConditions(): boolean {
        return !!this.currentUser
            && this.currentUser.hasAgreedToTermsAndConditions;
    }

    get shown(): Subject<void> {
        return this._shown;
    }

    constructor(
        private authService: AuthService,
        private http: HttpClient,
        private router: Router,
        private msalService: MsalService,
        private authConfigService: AuthConfigService
    ) {
        this.userSubscription = authService.userInfoSubject.subscribe(u => {
            this.currentUser = u;
            if (u && !u.hasAgreedToTermsAndConditions) {
               /* this.show();*/
                this.router.navigate(['/terms-and-conditions']);
            }
        });
    }

    ngOnDestroy(): void {
        if (this.userSubscription) {
            this.userSubscription.unsubscribe();
        }
    }

    async agree(): Promise<void> {
        const request = this.http.post<void>(this.endpoint, {}).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === 401) {
                    console.warn('T&C Agree: Received 401. Attempting full login redirect.');
                    // Instead of acquireTokenRedirect, trigger a full login flow
                    this.authService.login();
                    // Return a subject that never completes because of redirect
                    return new Subject<void>();
                } else {
                    // Re-throw other errors
                    return throwError(() => error);
                }
            })
        );

        try {
            const result = await request.toPromise();
            if (result !== undefined) {
                await this.authService.refresh();
            }
            return await Promise.resolve();
        } catch (error) {
            console.error("Error agreeing to T&C after potential token handling:", error);
            return await Promise.reject(error);
        }
    }

    show(): void {
        this._shown.next();
    }
}
